<template>
	<form @submit.prevent="submit">

		<div class="az_base_form_gr">
			<label class="az_base_lbl">{{ $t('name') }}</label>
			<input class="form-control az_base_inp"
			       type="text"
			       :class="{'is-invalid': $v.model.name.$error}"
			       v-model.trim="$v.model.name.$model">
		</div>

		<div class="az_base_form_gr">
			<label class="az_base_lbl">{{ $tc('menu.company', 1) }}</label>
			<select
				v-model="$v.model.companyId.$model"
				:class="['form-control az_base_inp', {'is-invalid': $v.model.companyId.$error}]">
				<option :value="null">{{ $t('select') }}</option>

				<option v-for="item in companies" :value="item.id">{{ item.name }}</option>
			</select>
		</div>


		<button class="btn az_base_btn btn-primary" type="submit">
			<i class="fa fa-save mr-1"></i>
			{{ $t('save') }}
		</button>

	</form>
</template>

<script>
import {required} from 'vuelidate/lib/validators';
import notification from "@/plugins/vue-notification-config";


export default {
	name: 'TheForm',
	props: {
		model: {
			type: Object,
			required: true,
		},
		edit: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			companies: []
		}
	},
	validations() {
		let options = {
			model: {
				name: {
					required,
				},
				companyId: {
					required
				}
			}
		};

		return options;
	},
	methods: {
		submit() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				return;
			}

			this.$emit('emit:submit');
		},
		async getCompanies() {
			try {
				const {data: {data}} = await this.$api.get('companies')
				this.companies = data
			} catch (e) {
				notification.error()
			}
		}
	},
	mounted() {
		this.getCompanies()
	}
};
</script>